var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.loading)?_c('page-loader',{staticClass:"loader-global"}):_vm._e(),_c('fade-transition',{attrs:{"duration":100,"mode":"out-in"}},[_c('router-view',{staticClass:"lower-index"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }